import { useState, useEffect } from "react";
import ReactSelect from 'react-select';
import Fetch from '../../../functions/Fetch';

function MultiSelect(props) {
  const [value, setValue] = useState(props.value || []);
  const [options, updateOptions] = useState(props.options);
  const [error, updateError] = useState(props.error);
  let className = '';
  let customStyle = {};

  const loadOptions = async () => {
    if (props.optionsEndpoint && props.optionsEndpoint.endpoint) {
      let url = props.optionsEndpoint.endpoint;
      let keyLabel = props.optionsEndpoint.label;
      let keyValue = props.optionsEndpoint.value;
      const params = props.optionsEndpoint.params ? props.optionsEndpoint.params : {};
      let rows = await Fetch.post(url, params);

      const tempOptions = rows.map(item => ({
        value: item[keyValue],
        label: item[keyLabel]
      }));
      updateOptions(tempOptions);
    }
  };
  
  useEffect(() => {
    loadOptions();
  }, []);

  useEffect(() => {
    if (props.optionsEndpoint) {
      if (props.value) {
        const updateValues = options.filter(option => (
          props.value.some(selectedValue => selectedValue === option.value)
        ));
        setValue(updateValues);
      }
    } else {
      setValue(props.value);
    }
  },[options]);

  const handleChange = selectedOptions => {
    setValue(selectedOptions);
    const target = {
      name: props.name,
      type: 'multiselect',
      value: selectedOptions.map(option => option.value)
    };
    props.onChange({ target: target });
  };

  if (props.error) {
    className = "is-invalid";
    customStyle = { border: '1px solid #dc3545' };
  }

  return (
    <div>
      <div style={customStyle}>
        <ReactSelect
          value={value}
          autoFocus={props.autoFocus ? true : false}
          isClearable={props.value !== null}
          name={props.name}
          placeholder={props.placeholder ? props.placeholder : 'Selecione'}
          options={options}
          onChange={handleChange}
          isDisabled={props.disabled}
          isMulti
        />
      </div>
      {props.error && (
        <span
          className="error invalid-feedback"
          style={{ display: 'inline' }}>
          {props.error}
        </span>
      )}
    </div>
  );
}

export default MultiSelect;
